import type { TranslationFunction } from '@/lib/hooks/use-locale';
import type { CrmNoteType } from '@plato/data/prisma';

export function getNoteTypeLabel(noteType: CrmNoteType, t: TranslationFunction): string {
    switch (noteType) {
        case 'VISIT':
        case 'EVENT':
            return t('notes__type__visit', { ns: 'notes' });
        case 'PHONE_CALL':
            return t('notes__type__phone_call', { ns: 'notes' });
        case 'NOTE':
        default:
            return t('notes__type__note', { ns: 'notes' });
    }
}
